import { Link, Tooltip } from '@material-ui/core';
import React, { Fragment, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import CollectionPinUnpin from '@components/CollectionPinUnpin';
import DeleteModal from '@components/DeleteModal';
import { toastError, toastSuccess } from '@components/Toast';

import { removeItemFromFilterResponse } from '@store/actions/FilterAction';

import ApiClient from '@lib/apiClient';

import { getCollectionTimeCount, getShortName } from '@utils/Util';

import CollectionAddAndEdit from '@/components/CollectionAddAndEdit';

const BuyerRequestCollectionItem = ({
	collection,
	index,
	imageType,
	collectionType,
	fetchCollectionList
}) => {
	const [openConfirmationModal, setConfirmationModal] = useState(false);
	const [selectedCollection, setSelectedCollection] = useState(null);
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const removeCollection = () => {
		let body = {
			id: collection.id
		};
		ApiClient.DELETE_WITH_BODY('deleteCollection', body)
			.then(({ data }) => {
				dispatch(removeItemFromFilterResponse(collection.id));
				setConfirmationModal(false);
				toastSuccess(data.message);
			})
			.catch(({ response }) => {
				toastError(response.data.message);
			});
	};

	const routeToCollectionView = () => {
		navigate('/collections/view/' + collection.id);
	};

	let docs =
		imageType === 'MOODBOARD_IAMGE'
			? collection?.moodboardImageList
			: collection.moodboardProductImageList;

	const renderSingleImage = () => {
		return (
			<Fragment>
				<img src={docs[0]} alt="" />
			</Fragment>
		);
	};

	const renderMultiImages = () => {
		return (
			<Fragment>
				{docs.length ? (
					<img src={docs[0]} alt="" />
				) : (
					<img src={`${process.env.PUBLIC_URL}/images/default_product.svg`} alt="" />
				)}

				{docs.length > 1 ? (
					<img src={docs[1]} alt="" />
				) : (
					<img src={`${process.env.PUBLIC_URL}/images/default_product.svg`} alt="" />
				)}
				{docs.length > 2 ? (
					<img src={docs[2]} alt="" />
				) : (
					<img src={`${process.env.PUBLIC_URL}/images/default_product.svg`} alt="" />
				)}
				{docs.length > 3 ? (
					<img src={docs[3]} alt="" />
				) : (
					<img src={`${process.env.PUBLIC_URL}/images/default_product.svg`} alt="" />
				)}
				{docs.length > 4 ? (
					<img src={docs[4]} alt="" />
				) : (
					<img src={`${process.env.PUBLIC_URL}/images/default_product.svg`} alt="" />
				)}
				{docs.length > 5 ? (
					<img src={docs[5]} alt="" />
				) : (
					<img src={`${process.env.PUBLIC_URL}/images/default_product.svg`} alt="" />
				)}
			</Fragment>
		);
	};

	return (
		<>
			<div className="single-collection-item" key={`collection_item_${index}`}>
				<div
					className={`${
						imageType === 'MOODBOARD_IAMGE' ? 'full-moodboard-layout' : 'masonry-layout'
					}`}
				>
					<Link to={`/collections/view/${collection.id}`} onClick={routeToCollectionView}>
						{imageType === 'MOODBOARD_IAMGE' ? renderSingleImage() : renderMultiImages()}

						<div className="brand-info d-flex justify-content-between">
							<div>
								<span className="brand-common-design">{collection?.brand}</span>
							</div>
							{collection?.creationPurposeTagResponse && (
								<div>
									<span className="status brown-2">
										{collection?.creationPurposeTagResponse?.text}
									</span>
								</div>
							)}
						</div>

						<CollectionPinUnpin collection={collection} />
					</Link>
				</div>
				<div className="design-details d-flex justify-content-between">
					<a
						href={`/collections/view/${collection.id}`}
						onClick={(e) => {
							if (e.button === 0) {
								e.preventDefault();
								routeToCollectionView();
							}
						}}
					>
						<div className="details">
							<Tooltip
								title={<span className="regular-14">{collection?.name}</span>}
								placement="top"
								arrow
							>
								<p className="collection-title hover-underline regular-12 mb-0 gray_dark_01 weight-500">
									{getShortName(collection?.name, 29)}&nbsp; (
									<span>
										<span className="green">{collection?.numOfCompletedDesign}/</span>
										{collection?.numOfDesign}
									</span>
									)
								</p>
							</Tooltip>
							<ul className="common-list-component mt-1">
								<li className="text-uppercase">
									{collectionType === 'BUYER_REQUEST'
										? collection?.createdBy
										: collection?.ownerName}
								</li>
								<li className="text-uppercase">{collection?.brand}</li>
								{collection?.season && (
									<li className="text-uppercase">{collection?.season.replace('_', '')}</li>
								)}

								<li className="text-uppercase">
									{getCollectionTimeCount(collection?.dateCreated)}
								</li>
							</ul>
						</div>
					</a>
				</div>

				<div className="option">
					<div className="dropdown">
						<button
							className="btn btn-default dropdown-toggle"
							type="button"
							id="menu1"
							data-toggle="dropdown"
							aria-expanded="false"
						>
							<img src={process.env.PUBLIC_URL + '/icons/more_icon.svg'} alt="more" />
						</button>
						<ul className="dropdown-menu dropdown-menu-right shadow-lg">
							<li className="px-4 pb-3">
								<span onClick={() => setSelectedCollection(collection)}>
									{' '}
									Edit collection details
								</span>
							</li>
							<li className="px-4 pb-3">
								<span onClick={() => setConfirmationModal(true)}>Delete</span>
							</li>
						</ul>
					</div>
				</div>
			</div>
			{openConfirmationModal && (
				<DeleteModal onRemove={removeCollection} onClose={() => setConfirmationModal(false)} />
			)}
			{selectedCollection?.id === collection?.id && (
				<CollectionAddAndEdit
					onSubmiCollection={() => {
						setSelectedCollection(null);
						fetchCollectionList();
					}}
					collectionId={selectedCollection?.id}
					onClose={() => setSelectedCollection(null)}
					type="EDIT"
				/>
			)}
		</>
	);
};

export default BuyerRequestCollectionItem;
